module.exports = __webpack_public_path__ + "static/06-cc174d61255c1387e9c0b00e78da1895.jpg";